import { AfterViewInit, Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { WidgetMapRegion } from '../../../models/widget';
import { MapEditorInstance } from './map-editor.instance';

let SVG = require('svg.js');
let SVGDraggable = require('svg.draggable.js');

@Component({
  selector: '[cw-map-region-point]',
  templateUrl: './region-point.component.html',
  //changeDetection: ChangeDetectionStrategy.OnPush
})
export class RegionPointComponent implements AfterViewInit {
  @Input() point: any;
  @Input() region: WidgetMapRegion;
  @Input() index: number;
  @Input() zoomLevel: number;
  @Input() isSelected: boolean;
  //@Input() svg: any;
  @Output() moved: EventEmitter<any> = new EventEmitter<any>();
  @Output() deleted: EventEmitter<any> = new EventEmitter<any>();
  @Output() selected: EventEmitter<any> = new EventEmitter<any>();
  //@ViewChild('circle') circle: ElementRef;
  circle: any;


  constructor(private instance: MapEditorInstance) {

  }

  ngAfterViewInit(): void {
    var self = this;
    this.circle = SVG.select(`.r_${this.region.id}_p_${this.index}`);

    let points = this.instance.getPoints();

    this.circle.on('click', (e) => {
      if (e.altKey) {
        this.deleted.emit(this.point);
      } else {
        this.selected.emit(this.point);
      }
    });

    this.circle.on('mouseenter', (e) => {

    });

    this.circle.on('mouseleave', (e) => {

    });

    this.circle.draggable().on('dragmove', (e) => {
      e.preventDefault();
      this.selected.emit(this.point);

      let newX = e.detail.p.x / this.zoomLevel, newY = e.detail.p.y / this.zoomLevel, nearest;

      points.forEach(function (p) {
        if (p != self.point) {
          var px = p.x, py = p.y,
            distance = Math.sqrt((px - newX) * (px - newX) + (py - newY) * (py - newY));

          if (distance > 0 && distance < 12) {
            if (nearest === undefined || nearest.distance > distance) {
              nearest = {
                'distance': distance,
                'x': px,
                'y': py
              };
            }
          }
        }
      });

      if (nearest && this.instance.snapping) {
        this.point.x = nearest.x;
        this.point.y = nearest.y;
      } else {
        this.point.x = newX;
        this.point.y = newY;
      }

      this.moved.emit({ x: this.point.x, y: this.point.y });
    });
  }

  @HostBinding('attr.class')
  get className() {
    return `r_${this.region.id}_p_${this.index}`;
  }

  @HostBinding('attr.cx')
  get cx() {
    return this.point.x * this.zoomLevel;
  }

  @HostBinding('attr.cy')
  get cy() {
    return this.point.y * this.zoomLevel;
  }

  @HostBinding('attr.r')
  get r() {
    return 3;
  }

  @HostBinding('attr.fill')
  get fillColor() {
    return this.isSelected ? '#f00' : '#000';
  }

  @HostBinding('attr.stroke')
  get strokeColor() {
    return '#000';
  }

  @HostBinding('attr.stroke-width')
  get strokeWidth() {
    return this.isSelected ? '1' : '0';
  }
}



// WEBPACK FOOTER //
// ./src/app/widgets/widget-detail/map-editor/region-point.component.ts